import { FormEvent, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { Logo } from "../../components/Logo";
import { SiteFooter } from "../../components/SiteFooter";
import { api, extractErrorMessage } from "../../lib/api";

const ALLOWED_DOMAIN = "@moatit.com";

export function Register() {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    const normalizedEmail = email.trim().toLowerCase();
    if (!normalizedEmail.endsWith(ALLOWED_DOMAIN)) {
      setError(`Only ${ALLOWED_DOMAIN} email addresses can register.`);
      return;
    }
    if (password.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }
    if (password !== password2) {
      setError("Passwords do not match.");
      return;
    }
    setSubmitting(true);
    try {
      await api.post("/api/auth/register", {
        name,
        email: normalizedEmail,
        password,
      });
      navigate("/pending");
    } catch (err) {
      setError(extractErrorMessage(err, "Registration failed"));
      setSubmitting(false);
    }
  }

  return (
    <>
      <div className="top-line" />
      <div className="page">
        <form className="card" onSubmit={onSubmit} noValidate>
          <Logo />
          <h1>Create your account</h1>
          <p className="sub">Sign up with your MOATiT email to get started.</p>
          <div className="domain-badge">{ALLOWED_DOMAIN} emails only</div>
          {error && (
            <div className="error-msg" role="alert">
              {error}
            </div>
          )}
          <div className="form-group">
            <label htmlFor="reg-name">Name</label>
            <input
              id="reg-name"
              className="form-input"
              type="text"
              placeholder="Your name"
              required
              autoFocus
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="reg-email">Email</label>
            <input
              id="reg-email"
              className="form-input"
              type="email"
              placeholder="you@moatit.com"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="reg-pw">Password</label>
            <input
              id="reg-pw"
              className="form-input"
              type="password"
              placeholder="Enter password"
              required
              minLength={8}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <p className="pw-hint">At least 8 characters</p>
          </div>
          <div className="form-group">
            <label htmlFor="reg-pw2">Confirm Password</label>
            <input
              id="reg-pw2"
              className="form-input"
              type="password"
              placeholder="Confirm password"
              required
              value={password2}
              onChange={(e) => setPassword2(e.target.value)}
            />
          </div>
          <button
            type="submit"
            className="btn btn--primary btn--block"
            disabled={submitting}
          >
            {submitting ? "Creating account..." : "Sign Up"}
          </button>
          <p className="alt-link">
            Already have an account? <Link to="/login">Sign in</Link>
          </p>
        </form>
      </div>
      <SiteFooter />
    </>
  );
}
